import { useQuery } from '@tanstack/react-query';

import { ApiPairs } from 'api';
import { Response } from 'api/apiBase/Response';
import { IMultiTransferTask } from 'api/apiPairs/models';

export const useMultiTransferTasks = (pairId: number, options?: { refetchInterval?: number }) =>
  useQuery<Response<{ items: IMultiTransferTask[] }>>({
    queryKey: ['pairs', pairId, 'multi-transfer', 'tasks'],
    queryFn: () => ApiPairs.getMultiTransferTasks(pairId),
    refetchInterval: options?.refetchInterval ?? 5000,
  });
